import type { UpdateInvoicesReviewStatusRequestPayload, UpdateInvoicesReviewStatusResponse } from '@weft/api-definition';
import { UpdateInvoicesReviewStatusResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { USE_INVOICES_OVERVIEWS_QUERY_KEY } from './use-invoices-overviews/use-invoices-overviews-consts';

export function useUpdateInvoicesReviewStatuses(options?: UseMutationOptions<UpdateInvoicesReviewStatusResponse, unknown, UpdateInvoicesReviewStatusRequestPayload, unknown>) {
  const queryClient = useQueryClient();

  return useMutation(async (updateInvoicesReviewStatusesRequest) => {
    const invoicesApi = getPrivateApi();
    const updateInvoiceReviewStatusResponse = await invoicesApi.updateInvoicesReviewStatuses({ updateInvoicesReviewStatusesRequest });
    await queryClient.invalidateQueries(USE_INVOICES_OVERVIEWS_QUERY_KEY);

    return UpdateInvoicesReviewStatusResponseSchema.parse(updateInvoiceReviewStatusResponse);
  },
  options,
  );
}